const messages = {
  title: "O BS Plus",
  description: "Opis stranice",
};

export default {
  messages,
};
